import mapiConfig from "../configs/mapi";
import { httpMStepsClient } from "./utils/httpService";
import sapiConfig from "../configs/sapi";
import qs from "qs";

//BASE_URL
const MAPI_BASE_URL = mapiConfig.api.domain;
const SAPI_BASE_URL = sapiConfig.api.domain;
const Controller = "/customer";

export const getPortalSalesOrder = async (queryParams: any) => {
  const methodPath = `${Controller}/portal-orders?${queryParams.toString()}`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "GET",
    path: methodPath,
  });
};

export const getPortalIssuesHistory = async (queryParams: any) => {
  const methodPath = `${Controller}/issues?${queryParams.toString()}`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "GET",
    path: methodPath,
  });
};

export const createIssueOrder = async (payload: any) => {
  const methodPath = `${Controller}/issues`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "POST",
    path: methodPath,
    body: payload,
  });
};

export const retrieveIssueSummary = async (issueId: any) => {
  const methodPath = `${Controller}/issues/${issueId}`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "GET",
    path: methodPath,
  });
};

export const getAllPortalDeliveryAppointments = async (params: any) => {
  const methodPath = `${Controller}/calendar/appointments?${qs.stringify(params)}`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "GET",
    path: methodPath,
  });
};

export const getWarehouseList = async () => {
  const methodPath = `${Controller}/calendar/warehouse-list`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "GET",
    path: methodPath,
  });
};

export const updateIssueOrder = async (issueId: string, payload: any) => {
  const methodPath = `${Controller}/issues/${issueId}`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "PATCH",
    path: methodPath,
    body: payload,
  });
};

export const shareIssueToOperation = async (payload: any) => {
  const methodPath = `${Controller}/issues/share-operation`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "POST",
    path: methodPath,
    body: payload,
  });
};

export const manualUpdateCustomerOrderStatus = async (
  _id: string,
  payload: any,
) => {
  const methodPath = `${Controller}/manual/portal-delivery-report/${_id}`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "POST",
    path: methodPath,
    body: payload,
  });
};

export const listAllPortalStates = async () => {
  const methodPath = `${Controller}/states/list`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "GET",
    path: methodPath,
  });
};

export const updateOrganization = async (id: string, organizationData: any) => {
  const methodPath = `${Controller}/organizations/${id}`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "PUT",
    path: methodPath,
    body: organizationData,
  });
};

export const getOrganizationsService = async (params: Record<string, any>) => {
  const methodPath = `${Controller}/organizations?${qs.stringify(params, { skipNulls: true })}`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "GET",
    path: methodPath,
  });
};

// ─── Sales: direct order creation ─────────────────────────────────────────────
// Sales routes are mounted at /go/orders (sales.route.js)
const SalesController = "/go/orders";

// Customers the logged-in sales user is assigned to (org.sales[] contains them).
// Response data: { email, customers: [...] }
export const getSalesCustomers = async () => {
  const methodPath = `${SalesController}/sales/customers`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "GET",
    path: methodPath,
  });
};

// Growers (sub-organizations) of one of the rep's customers
export const getSalesCustomerGrowers = async (organizationId: string) => {
  const methodPath = `${SalesController}/sales/customers/${organizationId}/growers`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "GET",
    path: methodPath,
  });
};

// SAP items + resolved pricelist for a customer — same report API the
// superadmin web uses (getSuperAdminCustomerProducts)
export const getSalesCustomerProducts = async (
  organizationId: string,
  params: { CardCode: string; State?: string },
) => {
  const methodPath = `/portal/report/products/item/sales/${organizationId}?${qs.stringify(params, { skipNulls: true })}`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "GET",
    path: methodPath,
  });
};

// Orders across the orgs this user can see (admin/owner, operation, or the
// org's sales rep). Pass `organization` to scope to one org. → listGoSalesOrders
export const getGoSalesOrders = async (queryParams: URLSearchParams) => {
  const methodPath = `${SalesController}?${queryParams.toString()}`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "GET",
    path: methodPath,
  });
};

export const createSalesOrder = async (payload: any) => {
  const methodPath = SalesController;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "POST",
    path: methodPath,
    body: payload,
  });
};

export const updateSalesOrder = async (id: string, payload: any) => {
  const methodPath = SalesController + `/${id}`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "PUT",
    path: methodPath,
    body: payload,
  });
};

export const getAppointmentsByDate = async (params: {
  startDate: string;
  endDate: string;
  organizationId: string;
  calendarId: string;
}) => {
  const methodPath = `${SalesController}/calendar?${qs.stringify(params)}`;
  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "GET",
    path: methodPath,
  });
};
